import { gql } from '@apollo/client';

export const CampaignOfferCounterProposalFields = gql`
  fragment CampaignOfferCounterProposalFields on CampaignOfferCounterProposal {
    id
    status
    proposedAmount
    proposedInfluencerFee
    message
    createdAt
    updatedAt
  }
`;
